export default "__VITE_ASSET__CmivkhNj__"